
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_84wkk_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_84wkk_1",
  "root": "awsui_root_mx3cw_84wkk_84",
  "hidden": "awsui_hidden_mx3cw_84wkk_119",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_84wkk_182",
  "initial-hidden": "awsui_initial-hidden_mx3cw_84wkk_194",
  "header": "awsui_header_mx3cw_84wkk_199",
  "header-replacement": "awsui_header-replacement_mx3cw_84wkk_200",
  "action": "awsui_action_mx3cw_84wkk_204",
  "action-slot": "awsui_action-slot_mx3cw_84wkk_208",
  "action-button": "awsui_action-button_mx3cw_84wkk_209",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_84wkk_213",
  "icon": "awsui_icon_mx3cw_84wkk_245",
  "text": "awsui_text_mx3cw_84wkk_249",
  "message": "awsui_message_mx3cw_84wkk_259",
  "action-wrapped": "awsui_action-wrapped_mx3cw_84wkk_263",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_84wkk_267",
  "icon-size-big": "awsui_icon-size-big_mx3cw_84wkk_271",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_84wkk_275",
  "content": "awsui_content_mx3cw_84wkk_279",
  "content-replacement": "awsui_content-replacement_mx3cw_84wkk_280",
  "dismiss": "awsui_dismiss_mx3cw_84wkk_284",
  "dismiss-button": "awsui_dismiss-button_mx3cw_84wkk_290",
  "type-error": "awsui_type-error_mx3cw_84wkk_294",
  "type-warning": "awsui_type-warning_mx3cw_84wkk_302",
  "type-success": "awsui_type-success_mx3cw_84wkk_310",
  "type-info": "awsui_type-info_mx3cw_84wkk_318"
};
  